import { render, staticRenderFns } from "./footerCopyright.vue?vue&type=template&id=01f97082&scoped=true&"
import script from "./footerCopyright.vue?vue&type=script&lang=js&"
export * from "./footerCopyright.vue?vue&type=script&lang=js&"
import style0 from "./footerCopyright.vue?vue&type=style&index=0&id=01f97082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f97082",
  null
  
)

export default component.exports